/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var productJsonElement = document.querySelector('[data-product-json]');


// When the "Notify me when available" button is clicked in a product page
function showNotifyAvailablityModal(event) {
  event.preventDefault();
  MicroModal.show('modal-1');

  // Show the sign up to be notified when back in stock form
  if (productJsonElement) {
    var jsonData = JSON.parse(productJsonElement.innerHTML);
    var productSKU = jsonData.selected_variant_sku;
    var ShowNotifyAvailibilityForm = jsonData.show_notify_when_available_btn

    // When the notify-when-available product tag is used
    if (ShowNotifyAvailibilityForm) {
      MktoForms2.loadForm("//pages.particle.io", "079-NUZ-391", 1917, function(form) {
        form.onSuccess(function() {
          // $(".micromodal__introtext").hide();
          // $(".oos-form-page1").hide();
          // $(".oos-email-ty").show();
          var occIntrotext = document.querySelector(".micromodal__introtext");
          var occPage1 = document.querySelector(".oos-form-page1");
          var occThankyou = document.querySelector(".oos-email-ty");
          occIntrotext.style.display = 'none';
          occPage1.style.display = 'none';
          occThankyou.style.display = 'block';
          return false;
        });
      });

      MktoForms2.whenReady(function(form) {
        form.vals({
          'productSKU': productSKU
        });
        var formEl = form.getFormElem()[0];
        var arrayFrom = Function.prototype.call.bind(Array.prototype.slice);

        // remove element styles from <form> and children
        var styledEls = arrayFrom(formEl.querySelectorAll('[style]')).concat(formEl);
        styledEls.forEach(function(el) {
          el.removeAttribute('style');
        });

        // disable remote stylesheets and local <style>s
        var styleSheets = arrayFrom(document.styleSheets);
        styleSheets.forEach(function(ss) {
          /*global mktoForms2BaseStyle mktoForms2ThemeStyle*/
          if (!window.mktoForms2BaseStyle) {
            window.mktoForms2BaseStyle = {};
          }
          if (!window.mktoForms2ThemeStyle) {
            window.mktoForms2ThemeStyle = {};
          }
          if ([mktoForms2BaseStyle,mktoForms2ThemeStyle].indexOf(ss.ownerNode) !== -1 || formEl.contains(ss.ownerNode) || ss.ownerNode.outerHTML.includes('<style>.mktoForm')) {
            ss.disabled = true;
          }
        });

        var boxes = document.querySelectorAll('.mktoCheckboxList, .mktoRadioList');
        for (var item of boxes) {
          item.parentNode.classList.add('mktoRadioCheckWrap');
        }
      });

      MktoForms2.whenRendered(function(form) {
        form.getFormElem()[0].setAttribute("data-mkto-ready", "true");
        var occSpinner = document.querySelector(".oos-spinner");
        occSpinner.style.display = 'none';
        var occSubtext = document.querySelector(".oos-form-subtext");
        occSubtext.style.display = 'block';
      });
    }
  }
}


// When the "Buy Now" button is clicked in a product page, update the buy quantity to the amount selected
function buyNowBtn(event, buyNowLink) {
  event.preventDefault();
  var selectEl = document.querySelector(".product-form__quantity") || '1';
  var selectVal = selectEl.options[selectEl.selectedIndex].value;
  window.location.href = buyNowLink + ':' + selectVal;
}


// Open modal to tell customer about wholesale pricing in wholesale store when products added to cart > $3000
document.addEventListener('product:added', function(event) {
  var price = event.detail.variant.price;
  var quantity = event.detail.quantity;
  var total = (price * quantity);
  if (total > 300000) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://unpkg.com/micromodal/dist/micromodal.min.js';
    document.body.appendChild(script);
    script.onload = function() {
      MicroModal.init();
      MicroModal.show('modal-2');
    };
  }
});

// Click event tracking for top bar link
function trackTopBarClick() {
  if (window.ga) {
    ga('send', 'event', 'Dev Kits Campaign', 'Top bar click');
  }
}


// FAQs accordian section
var accordianBtns = document.getElementsByClassName("faqs-button");
var contents = document.getElementsByClassName("faqs-item");
for (let i = 0; i < accordianBtns.length; i++) {
  accordianBtns[i].addEventListener("click", () => {
    for (let j = 0; j < contents.length; j++) {
      if (i == j) {
        contents[j].classList.toggle("content-transition");
      } else {
        contents[j].classList.remove("content-transition");
      }
    }
  });
}
